<template>
  <div class="container">
    <CommonFrame
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :moduleName="moduleName"
      :breadcrumb="showBreadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus"
      @btnClick='handleClick'
    >
      <div slot="info">
        <div v-if='isCancel'>
        <h4>
          <span>应付单号:</span>
          <span class="mr8">{{id}}</span>
          <span v-if="costChangeCode">成本变更单号:</span>
          <span v-if="costChangeCode">{{costChangeCode}}</span>
        </h4>
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
        </div>
        <div v-else>
          <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
        </div>
      </div>
      <div slot="formInfo">
        <div class="cardContainer">
          <div style="background: #fff; padding: 15px;">
            <div class="tabs">
              <lk-tabs type='card' v-model="currentTab">
                <lk-tab-pane label="应付单信息" name='0'>
                  <lk-form
                    :label-width='140'
                    label-position="right"
                    :model='info.financePayable'
                    ref="financePayable">
                    <lk-row :gutter='16'>
                      <lk-col span='10'>
                        <lk-form-item label='供应商:'>
                          <span>{{info.financePayable.supplierName}}</span>
                        </lk-form-item>
                      </lk-col>
                      <lk-col span='10' offset='2'>
                        <lk-form-item label='发票类型:'>
                         <span>{{info.financePayable.financePayableCreateType !==2 ? '首次发票录入' : '已校验批次成本调整'}}</span>
                        </lk-form-item>
                      </lk-col>
                    </lk-row>
                    <lk-row :gutter='16'>
                      <lk-col span='10'>
                        <lk-form-item label='发票编码:'>
                          <span>{{info.financePayable.invoiceCode}}</span>
                        </lk-form-item>
                      </lk-col>
                      <lk-col span='10' offset='2'>
                        <lk-form-item label='开票日期:'>
                         <span>{{info.financePayable.invoiceDate}}</span>
                        </lk-form-item>
                      </lk-col>
                    </lk-row>
                    <lk-row :gutter='16'>
                      <lk-col span='22'>
                        <lk-form-item label='应付明细:'>
                          <div class="payableGoods">
                            <lk-table border :columns="column1" :data="goodsList" class="plan-table"/>
                          </div>
                        </lk-form-item>
                      </lk-col>
                    </lk-row>
                    <lk-row :gutter='16'>
                      <lk-col span='10'>
                        <lk-form-item label='发票总金额:'>
                          <span>{{info.financePayable.invoiceAmount}}</span>
                        </lk-form-item>
                      </lk-col>
                      <lk-col span='10' offset='2'>
                        <lk-form-item label='总金额:' v-if="financePayableCreateType !== 2">
                          <span>{{info.financePayable.amount}}</span>
                        </lk-form-item>
                        <lk-form-item label='待抵消总金额:' v-else>
                          <span>{{info.financePayable.totalSetOffAmount}}</span>
                        </lk-form-item>
                      </lk-col>
                    </lk-row>
                    <lk-row :gutter='16'>
                      <lk-col span='10'>
                        <lk-form-item label='发票不含税金额:'>
                          <span>{{info.financePayable.invoiceAmountWithoutTax}}</span>
                        </lk-form-item>
                      </lk-col>
                      <lk-col span='10' offset='2'>
                        <lk-form-item label='确认不含税总金额:' v-if="financePayableCreateType !== 2">
                          <span>{{info.financePayable.amountWithoutTax}}</span>
                        </lk-form-item>
                        <lk-form-item label='待抵消不含税总金额:' v-else>
                          <span>{{info.financePayable.totalSetOffAmountWithoutTax}}</span>
                        </lk-form-item>
                      </lk-col>
                    </lk-row>
                    <lk-row :gutter='16'>
                      <lk-col span='10'>
                        <lk-form-item label='发票税额:'>
                          <span>{{info.financePayable.invoiceTotalTax}}</span>
                        </lk-form-item>
                      </lk-col>
                      <lk-col span='10' offset='2'>
                        <lk-form-item label='确认总税金:' v-if="financePayableCreateType !== 2">
                          <span>{{info.financePayable.totalTax}}</span>
                        </lk-form-item>
                        <lk-form-item label='待抵消总税额:' v-else>
                          <span>{{info.financePayable.totalSetOffTax}}</span>
                        </lk-form-item>
                      </lk-col>
                    </lk-row>
                    <lk-row :gutter='16'>
                      <lk-col span='10'>
                        <lk-form-item label='不含税金额差额:'>
<!--                          <span :class="{blue: amount.amountWithoutTaxBalance !== strZeroToFixed}">{{amount.amountWithoutTaxBalance}}</span>-->
                          <span :class="{blue: info.financePayable.amountWithoutTaxBalance !== 0}">{{info.financePayable.amountWithoutTaxBalance}}</span>
                        </lk-form-item>
                      </lk-col>
                      <lk-col span='10' offset='2' >
                        <lk-form-item label='税额差额:' v-if="financePayableCreateType !== 2">
                          <span :class="{blue: info.financePayable.taxBalance !== 0}">{{info.financePayable.taxBalance}}</span>
<!--                          <span :class="{blue: amount.totalTaxDiff !== strZeroToFixed}">{{amount.totalTaxDiff}}</span>-->
                        </lk-form-item>
                        <lk-form-item label='税额差额:' v-else>
                          <span :class="{blue: info.financePayable.taxBalance !== 0}">{{info.financePayable.taxBalance}}</span>
<!--                          <span :class="{blue: amount.totalTaxDiff !== strZeroToFixed}">{{amount.totalTaxDiff}}</span>-->
                        </lk-form-item>
                      </lk-col>
                    </lk-row>
                    <lk-row :gutter='16'>
                      <lk-col span='10'>
                        <lk-form-item label='备注:'>
                          <span>{{info.financePayable.comment}}</span>
                        </lk-form-item>
                      </lk-col>
                    </lk-row>
                  </lk-form>
                </lk-tab-pane>
                <lk-tab-pane label="成本变更单信息"  name='1' v-if="info.financeCostChangeVo">
                  <CostChangeBillTables
                    :info='info.financeCostChangeVo'
                    :financePayableCreateType='financePayableCreateType'
                  ></CostChangeBillTables>
                </lk-tab-pane>
              </lk-tabs>
            </div>
          </div>
          <br>
           <!-- 只有 应付单取消审批 才会展示 -->
          <lk-card title="" class="mb16" v-if="this.info.reasonCancel || this.info.cancelImgUrl">
            <lk-form
              label-position='right'
              :labelWidth='120'>
              <lk-row>
                <lk-col span='10' v-if="this.info.reasonCancel">
                  <lk-form-item label='取消原因:'>
                    <span>{{this.info.reasonCancel}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span='22' v-if="this.info.cancelImgUrl">
                  <lk-form-item label='附件:'>
                    <span class="blue downloadBtn" @click="downloadFile">下载附件</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
          </lk-card>
          <lk-card
            v-if="showActualBatch && isCancel"
            title="票折实际批次"
            style="marginTop: 20px;"
          >
            <lk-form
              :label-width='140'
              label-position="right"
            >
              <lk-row :gutter='16'>
                <lk-col span='10'>
                  <lk-form-item label='总票折金额(不含税):' >
                    <span>{{totalDiscountAmount}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span='8'>
                  <lk-form-item label='票折对应商品:' >
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col >
                  <lk-form-item label='' :label-width='50'>
                    <lk-table
                      :data='actualBatchInfo'
                      :columns='actualBatchColumns'
                      border
                    ></lk-table>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
          </lk-card>
        </div>
      </div>
    </CommonFrame>
    <lk-modal v-model="showLog" title="操作日志" footer-hide>
      <div class="records">
        <div class="record" v-for="(item,index) in recordlist" :key='index'  >
          {{item}}
        </div>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import axios from 'axios';
import utils from '@/libs/utils';
import CommonFrame from '../commonFrame.vue';
import expandRow from '../../finance/payableExpandRow';
import CostChangeBillTables from '../../../components/costChangeBillTables';
// import AnTable from '../../../components/table';

export default {
  components: {
    CommonFrame,
    CostChangeBillTables,
    // AnTable,
  },
  props: {
    approvalParams: {
      type: Object,
    },
  },
  data() {
    return {
      showActualBatch: false,
      actualBatchInfo: [],
      actualBatchColumns: [
        { title: '商品编码', key: 'drugSerialCode', minWidth: 130 },
        { title: '通用名', key: 'approvedDrugName', minWidth: 130 },
        { title: '商品名', key: 'goodsName', minWidth: 130 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
        { title: '单位', key: 'drugMinimumPackagingUnit', minWidth: 116 },
        {
          title: '本次票折金额',
          key: 'amountWithoutTaxBalance',
          minWidth: 116,
        },
        { title: '票折对应批次', key: 'goodsBatchSeq', minWidth: 116 },
      ],
      currentTab: '0',
      showLog: false,
      logData: [],
      workNo: '',
      node: '',
      moduleName: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批管理',
        },
        {
          name: 'approvalEdit',
          title: '应付单审批',
        },
      ],
      cancelBreadcrumb: [
        {
          name: 'work',
          title: '审批管理',
        },
        {
          name: 'approvalEdit',
          title: '应付单取消审批',
        },
      ],
      btns: [
        // {
        //   name: 'operate',
        //   text: '操作日志',
        //   type: 'default',
        // },
        // {
        //   name: 'reject',
        //   text: '驳回',
        //   type: 'default',
        // },
        // {
        //   name: 'pass',
        //   text: '通过',
        //   type: 'primary',
        // },
      ],
      infosArr: [],
      statusList: ['审批中', '审批通过', '审批拒绝'],
      id: '',
      costChangeCode: '',
      formModel: {},
      goodsList: [],
      referTypeMap: {
        1: '验收',
        2: '退货',
        3: '召回',
      },
      financePayableCreateType: null,
      column1: [],
      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h(expandRow, {
            props: {
              row: params.row,
            },
          }),
        },
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '单号', key: 'referCode', minWidth: 116 },
        {
          title: '单据来源',
          key: 'referType',
          minWidth: 116,
          render: (h, params) => h('span', `${this.referTypeMap[params.row.referType]}`),
        },
        { title: '商品通用名称', key: 'approvedDrugName', minWidth: 130 },
        {
          title: '原进项税率',
          key: 'taxRate',
          minWidth: 116,
          render: (h, params) => h('span', {
            props: {
              // type: 'text',
            },
            class: {
              noEqual: params.row.taxRate !== this.goodsList[0].taxRate,
            },

          }, `${params.row.taxRate}%`),
        },
        {
          title: '确认进项税率',
          key: 'realInputTaxRate',
          minWidth: 116,
          render: (h, params) => h('span', {
            props: {
              // type: 'text',
            },
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },

          }, `${params.row.realInputTaxRate}%`),
        },
        { title: '单价', key: 'priceBeforeTax', minWidth: 116 },
        { title: '确认进价', key: 'realPriceWithTax', minWidth: 116 },
        {
          title: ' 原总金额',
          key: 'originalTotalAmount',
          minWidth: 116,
          render: (h, { row }) => h('span', row.originalTotalAmount),
        },
        { title: '票折前总金额', key: 'amountBeforeDiscount', minWidth: 116 },
        { title: '票折不含税金额', key: 'discountWithoutTax', minWidth: 136 },
        { title: '票折税额', key: 'discountTax', minWidth: 116 },
        { title: '确认总金额', key: 'confirmedTotalAmount', minWidth: 116 },
        {
          title: ' 待抵消金额',
          key: 'setOffAmount',
          minWidth: 116,
        },
        {
          title: '确认不含税单价',
          key: 'realPriceAfterTax',
          minWidth: 136,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },
          }, params.row.realPriceAfterTax),
        },
        {
          title: '确认不含税总金额',
          key: 'realTotalPriceAfterTax',
          minWidth: 144,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },
          }, params.row.realTotalPriceAfterTax),
        },
        {
          title: '确认总税金',
          key: 'realTotalTax',
          minWidth: 116,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },
          }, params.row.realTotalTax),
        },
        {
          title: '不含税总差额',
          key: 'amountWithoutTaxBalance',
          minWidth: 116,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxRate !== params.row.realInputTaxRate,
            },
          }, params.row.amountWithoutTaxBalance),
        },
      ],
      info: {
        financePayable: {
          type: 1, // 验收1，退货2
          invoiceCode: '',
          invoiceDate: '',
          supplierId: '',
          comment: '',
          invoiceAmount: '',
          invoiceTotalTax: '',
        },
        financeCostChangeVo: {},
        purchaseMedicineInfoVoList: [],
      },
      strZeroToFixed: '0.00',
    };
  },
  computed: {
    totalDiscountAmount() { // 总票折金额(不含税)
      const amount = this.actualBatchInfo.reduce((pre, current) => utils.formatNum(pre + Number(current.amountWithoutTaxBalance), 10), 0);
      return amount;
    },
    amount() {
      const result = {
        totalPrice: 0, // 总金额
        totalPriceAfterTax: 0, // 不含税金额
        totalTax: 0, // 总税额
        amountWithoutTaxBalance: 0, // 不含税差额
        totalTaxDiff: 0, // 税差额 = 发票税额 - 不含税金额
        checkTax: false,
      };
      if (this.goodsList.length) {
        const firstTax = this.goodsList[0].taxRate;
        this.goodsList.forEach((item) => {
          result.totalPrice += Number(item.realTotalPriceBeforeTax);
          result.totalPriceAfterTax += Number(item.totalPriceAfterTax);
          result.totalTax += Number(item.totalTax);
          // result.amountWithoutTaxBalance += item.amountWithoutTaxBalance;
          if (item.taxRate !== firstTax) {
            result.checkTax = true;
          }
        });
      }
      result.totalPrice = result.totalPrice.toFixed(2);
      result.totalPriceAfterTax = result.totalPriceAfterTax.toFixed(2);
      result.totalTax = result.totalTax.toFixed(2);
      result.amountWithoutTaxBalance = ((this.info.financePayable.invoiceAmountWithoutTax - result.totalPriceAfterTax) || 0).toFixed(2);
      result.totalTaxDiff = (this.info.financePayable.invoiceTotalTax - result.totalTax).toFixed(2);
      return result;
    },
    recordlist() {
      const result = [];
      this.logData.forEach((el, index) => {
        let str = `${index + 1}.${el.time}, 由 ${el.name}${el.content} 。`;
        if (el.newValue && el.oldValue) {
          str += `修改了，旧值：${el.oldValue}，新值：${el.newValue}.`;
        }
        result.push(str);
      });
      return result;
    },
    showBreadcrumb() {
      return this.moduleName === 'single_finance_payable' ? this.breadcrumb : this.cancelBreadcrumb;
    },
    isCancel() {
      return this.moduleName === 'single_finance_payable';
    },
  },
  methods: {
    transformUrlToHttps(url) {
      if (!url) {
        return
      }
      let index = url.indexOf(':');
      if (index !== -1) {
        let str = url.slice(index);
        console.log(`https${str}`);
        return `https${str}`;
      }
    },
    handleClick(text) {
      console.log(text);
      if (text === 'operate') {
        this.getRecord();
        this.showLog = true;
      }
    },
    // 获取退货单信息
    getInfo(businessUrl) {
      // return new Promise((resolve, reject) => {
      axios.get(businessUrl).then((res) => {
        const temp = res.data.data;
        this.id = temp.financePayable.code;
        this.financePayableCreateType = temp.financePayable.financePayableCreateType;
        this.columns.forEach((item) => {
          if (item.key == 'realTotalPriceAfterTax') {
            item.title = this.financePayableCreateType == 2 ? '待抵消不含税总金额' : '确认不含税总金额';
          }
          if (item.key == 'realTotalTax') {
            item.title = this.financePayableCreateType == 2 ? '待抵消总税金' : '确认总税金';
          }
        });
        if (this.financePayableCreateType !== 2) {
          this.column1 = this.columns.filter(col => col.key !== 'originalTotalAmount' && col.key !== 'setOffAmount');
        } else {
          this.column1 = this.columns;
        }
        this.btns.push({
          name: 'reject',
          text: '驳回',
          type: 'default',
        }, {
          name: 'pass',
          text: '通过',
          type: 'primary',
          disabled: temp.passable === 2,
        });
        // 应付明细列表
        temp.financePayableInfoList.forEach((item) => {
          const result = item;
          this.goodsList.push(result);
        });
        temp.financePayable.invoiceDate = temp.financePayable.invoiceDate ? utils.exchangeTime(temp.financePayable.invoiceDate) : '';
        temp.cancelImgUrl = this.transformUrlToHttps(decodeURIComponent(temp.cancelImgUrl));
        this.info = utils.deepClone(temp);
        if (this.isCancel) {
          this.infosArr.push({ name: '门店名称', value: this.info.financePayable.storeName },
            { name: '供应商名称', value: this.info.financePayable.supplierName },
            { name: '创建人', value: this.info.financePayable.createUserName },
            { name: '创建时间', value: utils.exchangeTimeToSecond(this.info.financePayable.createTime) });
        } else {
          this.infosArr.push(
            { name: '申请单号', value: this.info.financePayable.code },
            { name: '申请人', value: this.info.financePayable.createUserName },
            { name: '申请时间', value: utils.exchangeTimeToSecond(this.info.financePayable.modifiedTime) },
          );
        }
        // 成本变更单有可能不存在
        if (temp.financeCostChangeVo) {
          const costChangeTemp = temp.financeCostChangeVo; // 成本变更单号
          this.info.totalSaleBalance = costChangeTemp.totalSaleBalance; // 成本变更单号totalSaleBalance
          this.costChangeCode = costChangeTemp.financeCostChange.code;
        }
        if (temp.rebateInfoList && temp.rebateInfoList.length) {
          this.showActualBatch = true;
          temp.rebateInfoList.forEach((item) => {
            const result = item;
            result.amountWithoutTaxBalance = item.submitAmount;
            this.actualBatchInfo.push(result);
          });
        }
        // resolve();
      }).catch((err) => {
        // reject(err);
        utils.handleError(err);
      });
      // });
    },
    // 后续增加操作日志  暂时保留
    getRecord() {
      // goodsService.getRecord({ businessId: this.goodsStore.id }).then((res) => {
      //   if (res.data.status === 200) {
      //     // this.record
      //     this.logData = [];
      //
      //     res.data.data.forEach((item) => {
      //       const format = {
      //         content: item.content,
      //         newValue: item.newValue,
      //         oldValue: item.oldValue,
      //         time: utils.exchangeTimeToSecond(item.time),
      //         Id: item.userId,
      //         name: item.userName,
      //       };
      //       this.logData.push(format);
      //     });
      //   } else {
      //     this.$Message.error(res.data.error);
      //   }
      // }).catch((err) => {
      // utils.handleError(err);
      // });
    },
    downloadFile() {
      window.open(this.info.cancelImgUrl);
    },
  },
  mounted() {
    // this.getInfo();
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;
    this.getInfo(this.approvalParams.businessUrl);
    // this.getDetails();
    // this.getInfo(this.approvalParams.businessUrl);
  },
};
</script>

<style scoped>
  .cardContainer {
    margin-bottom: 16px;
  }
  .record{
    font-size: 14px;
    padding: 0 10px;
    line-height: 2
  }
  .records{
    max-height: 60vh;
    overflow: auto
  }
  .padding-span{
    padding-right:15px;
  }
  .total {
    margin-top: 12px;
    color: #1890ff;
  }
  .blue {
    color: #1890FF;
  }

  .downloadBtn {
    cursor: pointer;
  }
</style>
